import styled from 'styled-components';

export const HeaderContainer = styled.header`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.light};
  height: fit-content;
  margin: 0 auto;

  @media (min-width: 601px) {
    padding: 1em 5em 0em 5em;
  }

  img {
    display: block;
    max-width: 100%;
  }

  div.social-media-icons {
    display: flex;
    gap: 24px;
  }

  .header__logo {
   display: flex;
   justify-content: space-between;
   width: 100%;
  }

  .header__powered {
    display: flex;
    align-items: center;
  }

  .header__powered-text {
    color: #808080;
    font-size: 13px;
    line-height: 17px;
  }

  .header__powered_mobile {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .header__powered_mobile .header__powered-text{

  }

  .header__powered_mobile .logo {
    width: 140px;
  }
`;

